import { renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "top"),
    _renderSlot(_ctx.$slots, "default"),
    _renderSlot(_ctx.$slots, "bottom")
  ], 64))
}